<template>
  <div class="finance-page">
    <header class="finance-header">
      <button
        type="button"
        class="back-btn"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>{{ $t('moneybag.myWallet') }}</h1>
      <button
        type="button"
        class="header-action"
        @click="$router.push('/moneybag')"
      >
        <van-icon name="filter-o" />
      </button>
    </header>

    <main class="finance-main">
      <section
        v-if="listShow"
        class="empty-card"
      >
        <van-empty :description="$t('moneybag.detailsEmpty')" />
      </section>

      <section
        v-if="data && data.length"
        class="record-list"
      >
        <article
          v-for="(item, index) in data"
          :key="item.id || item.time || index"
          class="record-card"
        >
          <div class="record-head">
            <div>
              <span class="record-label">{{ $t('shopds.money') }}</span>
              <strong class="record-amount">{{ item.money }}</strong>
            </div>
            <span
              v-if="item.status==0"
              class="status-pill pending"
            >
              {{ $t('shopds.cashstating') }}
            </span>
            <span
              v-if="item.status==1"
              class="status-pill success"
            >
              {{ $t('shopds.cashstat') }}
            </span>
            <span
              v-if="item.status==2"
              class="status-pill failed"
            >
              {{ $t('shopds.cashstatfail') }}
            </span>
          </div>
          <div class="record-meta">
            <span>{{ $t('shopds.time') }}</span>
            <b>{{ formatBrowserTime(item.time) }}</b>
          </div>
          <p
            v-if="item.status==2"
            class="record-memo"
          >
            {{ item.memo }}
          </p>
        </article>
      </section>
    </main>
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {
        DropdownMenu,
        DropdownItem,
        Icon
    } from 'vant';

    import { Empty } from 'vant';

    Vue.use(Empty);
    Vue.use(DropdownMenu).use(DropdownItem).use(Icon);

    export default {
        name: "Moneybag",
        data() {
            return {
                lang:this.$i18n.locale||"zh_cn",
                data: null,
                listShow:false
            };
        },
        created() {
            this.$parent.footer('moneybag');
        },
        mounted() {
            Fetch('/user/cash_search').then(r => {
                this.showError(r.data.length);
                this.data = r.data;
            })
        },
        methods: {
            showError(len){
                len == 0 ? this.listShow = true : this.listShow = false
            }
        }
    };
</script>

<style lang="less" scoped>
.finance-page {
    min-height: 100vh;
    box-sizing: border-box;
    background: #f4f5fb;
    color: #061429;
}

.finance-header {
    position: sticky;
    top: 0;
    z-index: 10;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f7f8fd;
}

.finance-header h1 {
    margin: 0;
    color: #202637;
    font-size: 14px;
    font-weight: 500;
    line-height: 50px;
}

.back-btn,
.header-action {
    position: absolute;
    top: 10px;
    width: 28px;
    height: 28px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #071426;
    font-size: 22px;
}

.back-btn {
    left: 8px;
}

.header-action {
    right: 14px;
    color: #3e4656;
    font-size: 20px;
}

.finance-main {
    padding: 16px 16px 88px;
}

.empty-card,
.record-card {
    overflow: hidden;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 8px 20px rgba(30, 45, 82, .045);
}

.record-card {
    padding: 16px 18px;
    box-sizing: border-box;
}

.record-card + .record-card {
    margin-top: 12px;
}

.record-head,
.record-meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 0;
}

.record-label,
.record-meta span {
    display: block;
    color: #8b93a3;
    font-size: 12px;
    line-height: 18px;
}

.record-amount {
    display: block;
    margin-top: 4px;
    color: #ff4551;
    font-size: 14px;
    font-weight: 700;
    line-height: 22px;
}

.status-pill {
    flex: 0 0 auto;
    max-width: 42%;
    overflow: hidden;
    padding: 5px 9px;
    border-radius: 999px;
    color: #fff;
    font-size: 12px;
    line-height: 16px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.status-pill.pending {
    background: #ff9f2e;
}

.status-pill.success {
    background: #38bf62;
}

.status-pill.failed {
    background: #8f98a8;
}

.record-meta {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #edf0f6;
}

.record-meta b {
    min-width: 0;
    overflow: hidden;
    color: #687083;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    text-align: right;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.record-memo {
    margin: 10px 0 0;
    color: #8b93a3;
    font-size: 12px;
    line-height: 18px;
}
</style>
